"use client"

import { Banner } from '@/app/components/Banner'
import ServiceContent from '@/app/components/ServiceContent'
import { webDevelopmentImg } from '@/assets/imgs'
import { useTranslations } from 'next-intl'


const WebDevelopment = () => {
  const  t  = useTranslations()
  return (
    <>
      <Banner
        subUrl={t('links.services')}
        name={t('links.webDevelopment')}
        description={t('webDevelopment.bannerDescription')}
        className='bg-webDevelopment'
      />
      <ServiceContent
        title={t('links.webDevelopment')}
        header={t('webDevelopment.header')}
        subContent={t('webDevelopment.subTitle')}
        content={t('webDevelopment.content')}
        img={webDevelopmentImg}
      />
    </>
  )
}

export default WebDevelopment
